import { Button as MuiButton } from '@mui/material'
import { ButtonProps } from './Button.types'

export const Button = ({
  children,
  className,
  icon,
  disableRipple = true,
  label,
  color = 'primary',
  ...otherProps
}: ButtonProps) => {
  return (
    <MuiButton
      color={color}
      aria-label={label}
      disableRipple={disableRipple}
      startIcon={icon}
      className={className}
      sx={{
        padding: '4px 16px',
        borderRadius: '3px',
        '& .MuiButton-startIcon': {
          width: '20px',
          height: '20px',
        },
      }}
      {...otherProps}
    >
      {children}
    </MuiButton>
  )
}
